import gsap from 'gsap';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';
import { ease1 } from '../../easings';

const ANIMATION_SELECTORS = {
    HERO: {
        GALLERY: '.js-hero-gallery',
        INFO: '.js-hero-info',
    },
    PROPERTIES: {
        CONTAINER: '.js-properties-container',
        PROPERTY: '.js-property',
    },
    VIDEO: {
        CONTAINER: '.js-pr-video',
        ICON: '.js-video-icon',
        TEXT: '.js-video-text',
    },
    ABOUT: {
        CONTENT: '.js-about-content',
        TOP: '.js-about-top',
        BOTTOM: '.js-about-bottom',
        ACCORDIONS: '.js-about-accordions',
    },
    TEXT_BLOCK: {
        CONTAINER: '.js-text-block',
        TITLE: '.js-text-block-title',
        TEXT: '.js-text-block-text',
    },
    DOCUMENTS: {
        CONTAINER: '.js-documents',
        TITLE: '.js-documents-title',
        DESCRIPTION: '.js-documents-description',
        SLIDER: '.js-documents-slider',
        CONTROLS: '.js-documents-controls',
        ITEM: '.js-pr-document',
    },
    OTHER_PRODUCTS: '.js-pr-other-products',
    BREADCRUMBS: 'a-breadcrumbs',
    BREADCRUMB: '.a-breadcrumbs__item',
};

const init = () => {
    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    firstViewportTimeline
        .set(ANIMATION_SELECTORS.BREADCRUMBS, { opacity: 1 })
        .fromTo(
            [ANIMATION_SELECTORS.HERO.GALLERY, ANIMATION_SELECTORS.HERO.INFO],
            { opacity: 0 },
            {
                delay: 0.5,
                opacity: 1,
                stagger: 0.5,
            },
        )
        .fromTo(
            ANIMATION_SELECTORS.BREADCRUMB,
            { opacity: 0 },
            { duration: 1.4, opacity: 1, delay: -0.8, stagger: 0.17 },
        );

    gsap.fromTo(
        ANIMATION_SELECTORS.PROPERTIES.PROPERTY,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            stagger: 0.3,
            ease: ease1,
            duration: 1,
            scrollTrigger: {
                trigger: ANIMATION_SELECTORS.PROPERTIES.CONTAINER,
                start: 'top bottom-=30%',
            },
        },
    );

    gsap.fromTo(
        [ANIMATION_SELECTORS.VIDEO.ICON, ANIMATION_SELECTORS.VIDEO.TEXT],
        {
            opacity: 0,
        },
        {
            opacity: 1,
            stagger: 0.3,
            ease: ease1,
            duration: 1,
            scrollTrigger: {
                trigger: ANIMATION_SELECTORS.VIDEO.CONTAINER,
                start: 'center center+=20%',
            },
        },
    );

    gsap.fromTo(
        [ANIMATION_SELECTORS.ABOUT.TOP, ANIMATION_SELECTORS.ABOUT.BOTTOM],
        { opacity: 0, y: 15 },
        {
            opacity: 1,
            y: 0,
            stagger: 1,
            ease: ease1,
            duration: 1,
            scrollTrigger: {
                trigger: ANIMATION_SELECTORS.ABOUT.CONTENT,
                start: 'top bottom-=30%',
            },
        },
    );

    gsap.fromTo(
        ANIMATION_SELECTORS.ABOUT.ACCORDIONS,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            delay: DEVICE_WIDTH.isDesktop ? 0.6 : 0,
            ease: ease1,
            duration: 1,
            scrollTrigger: {
                trigger: ANIMATION_SELECTORS.ABOUT.ACCORDIONS,
                start: 'top bottom-=30%',
            },
        },
    );

    const textBlocks = document.querySelectorAll(ANIMATION_SELECTORS.TEXT_BLOCK.CONTAINER);

    textBlocks.forEach((textBlock) => {
        const titleElement = textBlock.querySelector(ANIMATION_SELECTORS.TEXT_BLOCK.TITLE);
        const textElement = textBlock.querySelector(ANIMATION_SELECTORS.TEXT_BLOCK.TEXT);

        gsap.fromTo(
            titleElement,
            { opacity: 0, y: '80%' },
            {
                opacity: 1,
                y: 0,
                ease: ease1,
                duration: 1,
                scrollTrigger: {
                    trigger: textBlock,
                    start: 'top bottom-=30%',
                },
            },
        );

        gsap.fromTo(
            textElement,
            { opacity: 0 },
            {
                opacity: 1,
                ease: ease1,
                duration: 1,
                delay: 0.7,
                scrollTrigger: {
                    trigger: textBlock,
                    start: 'top bottom-=30%',
                },
            },
        );
    });

    const documentsTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ANIMATION_SELECTORS.DOCUMENTS.CONTAINER,
            start: 'top bottom-=30%',
        },
        defaults: { duration: 1, ease: ease1 },
    });

    documentsTimeline
        .set(ANIMATION_SELECTORS.DOCUMENTS.ITEM, { opacity: 0, x: '30vw' })
        .fromTo(ANIMATION_SELECTORS.DOCUMENTS.TITLE, { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1 })
        .fromTo(ANIMATION_SELECTORS.DOCUMENTS.DESCRIPTION, { opacity: 0 }, { opacity: 1, duration: 1.4, delay: -0.5 })
        .to(ANIMATION_SELECTORS.DOCUMENTS.ITEM, { opacity: 1, x: '0vw', delay: -1 })
        .fromTo(ANIMATION_SELECTORS.DOCUMENTS.CONTROLS, { opacity: 0 }, { duration: 1.4, opacity: 1, delay: -1 });

    gsap.fromTo(
        [ANIMATION_SELECTORS.ABOUT.TOP, ANIMATION_SELECTORS.ABOUT.BOTTOM],
        { opacity: 0, y: 15 },
        {
            opacity: 1,
            y: 0,
            stagger: 1,
            ease: ease1,
            duration: 1,
            scrollTrigger: {
                trigger: ANIMATION_SELECTORS.ABOUT.CONTENT,
                start: 'top bottom-=30%',
            },
        },
    );

    gsap.fromTo(
        ANIMATION_SELECTORS.OTHER_PRODUCTS,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            ease: ease1,
            duration: 1,
            scrollTrigger: {
                trigger: ANIMATION_SELECTORS.OTHER_PRODUCTS,
                start: 'top bottom-=30%',
            },
        },
    );
};

const _module = { init };

export default _module;
